import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import styles from './incoming-storms-card.module.css';

export default function IncomingStormsCard({ renderEvents }) {
    return (
        <Box className={styles.eventsSection}>
            <div className={styles.sectionHeader}>
                <Typography variant="h6">Incoming Storms</Typography>
            </div>
            <div className={styles.eventsContent}>
                {renderEvents()}
            </div>
        </Box>
    )
}